/**
 * データを表示用に整形
 *
 * @param {Array<ReservationRecord>} records
 * @param {Array<moment>} days 日付表示順
 */
export default function (records, days) {
    const displayDays = days.map((date) => {
        return date.format('YYYYMMDD');
    });

    return records
        .sort((a, b) => {
            // 日付順
            if (b.date < a.date) {
                return 1;
            }
            if (a.date < b.date) {
                return -1;
            }

            // コード順
            return a.code - b.code;
        })
        .reduce((data, record) => {
            // 構造を変更
            let target = data.find((d) => {
                return d.code === record.code;
            });
            if (!target) {
                target = {
                    code: record.code,
                    room: record.room,
                    morning: displayDays.map(d => ''),
                    afternoon: displayDays.map(d => ''),
                    night: displayDays.map(d => ''),
                };
                data.push(target);
            }

            const dayIndex = displayDays.findIndex(d => d === record.date);
            target.morning[dayIndex] = record.morning + '';
            target.afternoon[dayIndex] = record.afternoon + '';
            target.night[dayIndex] = record.night + '';

            return data;
        }, []);
}
